export const buildVendorWebsiteUrl = (domain) => {
  if (!domain || typeof domain !== 'string') {
    return '';
  }

  const normalizedDomain = domain.trim().replace(/^https?:\/\//i, '').replace(/\/$/, '');

  return normalizedDomain ? `https://${normalizedDomain}` : '';
};